import { listHistory } from "../useLearning";
import { HISTORY_DEFAULT_PAGE_SIZE } from "./catalogText";
import usePagedList from "./usePagedList";

export const EMPTY_HISTORY_FILTERS = Object.freeze({
  product: "", category: "", cause: "", kind: "", status: "", manual: "", date_from: "", date_to: "", q: "",
});
const TEXT_KEYS = Object.freeze(["q"]);
// a category belongs to its product and a cause to its category: choosing a wider one clears the narrower ones
const RESETS = Object.freeze({ product: { category: "", cause: "" }, category: { cause: "" } });
const NONE = Object.freeze([]);

const loadPage = (query, signal) => listHistory(query, { signal });

/**
 * The learning history's data, one server page at a time (newest first): {filters, setFilter, clearFilters, status, items,
 * causes, total, all, error, offset, setOffset, limit, setLimit, refresh}. `causes` is the per-cause summary strip; `all`
 * counts every learned case, `total` the ones these filters match. The search waits FILTER_DEBOUNCE_MS; every other filter
 * queries at once. The dropdown choices (kinds, statuses, undo reasons, products) are the page's (useCatalogOptions).
 * See usePagedList for loading, cancelling and the not-connected states.
 */
export default function useHistory({ enabled = true } = {}) {
  const list = usePagedList({
    enabled, empty: EMPTY_HISTORY_FILTERS, textKeys: TEXT_KEYS, resets: RESETS, limit: HISTORY_DEFAULT_PAGE_SIZE, load: loadPage,
  });
  const { data, status, error, filters, setFilter, clearFilters, offset, setOffset, limit, setLimit, refresh } = list;
  return {
    status, error, filters, setFilter, clearFilters, offset, setOffset, limit, setLimit, refresh,
    items: (data && data.items) || NONE,
    causes: (data && data.causes) || NONE,
    total: (data && data.total) || 0,
    all: (data && data.all) || 0,
  };
}

/** The server's label for `key` in an options list ({key, label}[]), else the key itself. */
export const labelOf = (list, key) => {
  const found = (list || []).find((o) => o.key === key);
  return found ? found.label : key;
};
